import { cn } from "@/components/podkit/lib/cn";
import { Dialog, DialogContent } from "@/components/podkit/modal/Modal";
import { type TrackLocation } from "@/hooks/use-segment";
import { CreateEnvironmentDetailsLayout } from "@/routes/environments/create/CreateEnvironmentDetailsLayout";
import { type FC } from "react";
import { useNavigate } from "react-router-dom";

export const CreateEnvironmentModal: FC<{
    open: boolean;
    onClose: () => void;
    disableProjectSelection?: boolean;
    "data-track-location": TrackLocation;
}> = ({ open, onClose, disableProjectSelection, "data-track-location": dataTrackLocation }) => {
    const navigate = useNavigate();

    const onOpenChange = (open: boolean) => {
        if (!open) {
            onClose();
            navigate({ hash: "" }, { replace: true });
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                data-track-location={dataTrackLocation}
                className={cn(
                    "top-[2rem] h-auto max-h-[calc(100vh-4rem)] max-w-[600px] translate-y-0 md:top-[7rem]",
                    open && "overflow-y-auto md:max-h-[calc(100vh-14rem)]",
                    "data-[state=closed]:slide-out-to-top-[0%] data-[state=open]:slide-in-from-top-[0%]",
                )}
                data-testid="create-environment-modal"
            >
                <CreateEnvironmentDetailsLayout
                    onClose={onClose}
                    initialContextURL={""}
                    disableProjectSelection={disableProjectSelection}
                />
            </DialogContent>
        </Dialog>
    );
};
